import Card from '@components/Card';
import Title from '@components/Title/Title';
import { FC } from 'react';
import GraduateHat from './GraduateHat';
import * as style from './index.css';

export const NOT_FOUND = 'notFound';
export const NO_PARAMS = 'noParams';

interface Props {
  type?: string;
}

const Error: FC<Props> = ({ type }) => {
  const { title, mainMessage, subMessage, context } = getMessages(type);

  return (
    <Card className={style.wrapper} data-testid={`test_error_${context}`}>
      <Title title={title} context={context} />
      <div className={style.content}>
        <p className={style.mainMessage}>{mainMessage}</p>
        <div className={style.iconWrapper}>
          <GraduateHat dataTestId='test_svg_hat' />
        </div>
        <p>{subMessage}</p>
      </div>
    </Card>
  );
};

const getMessages = (
  type?: string,
): {
  title: string;
  mainMessage: string;
  subMessage: string;
  context: string;
} => {
  switch (type) {
    case NOT_FOUND:
      return {
        title: 'Formation inconnue',
        mainMessage:
          "Oups ! Il semble qu'une erreur humaine se soit glissée dans cette page.",
        subMessage: 'Les paramètres semblent mal utilisés.',
        context: type,
      };
    case NO_PARAMS:
      return {
        title: 'Formation manquante',
        mainMessage:
          "Oups ! Il semble qu'il soit impossible de charger le formulaire.",
        subMessage: "Aucun paramètre n'est reçu.",
        context: type,
      };
    default:
      return {
        title: 'Erreur…',
        mainMessage: "Oups ! Il semble qu'une erreur soit survenue.",
        subMessage: "C'est notre faute, non la vôtre.",
        context: 'error',
      };
  }
};

export default Error;
